export class BaseConnection {
    queue = [];
    disconnectionDetails = null;
    onDisconnectCallback = null;
    onMessageCallback = null;
    onModeChangeCallback = null;
    onDebug;
    constructor(config = {}) {
        this.onDebug = config.onDebug;
    }
    debug(info) {
        if (this.onDebug)
            this.onDebug(info);
    }
    onMessage(callback) {
        this.onMessageCallback = callback;
        const queue = this.queue;
        this.queue = [];
        if (queue.length > 0) {
            // Make sure the queue is flushed after the constructors finishes and
            // classes are initialized.
            queueMicrotask(() => {
                queue.forEach(callback);
            });
        }
    }
    onDisconnect(callback) {
        this.onDisconnectCallback = callback;
        const details = this.disconnectionDetails;
        if (details) {
            // Make sure the event is triggered after the constructors finishes and
            // classes are initialized.
            queueMicrotask(() => {
                callback(details);
            });
        }
    }
    onModeChange(callback) {
        this.onModeChangeCallback = callback;
    }
    updateMode(mode) {
        this.onModeChangeCallback?.(mode);
    }
    disconnect(details) {
        if (!this.disconnectionDetails) {
            this.disconnectionDetails = details;
            this.onDisconnectCallback?.(details);
        }
    }
    handleMessage(parsedEvent) {
        if (this.onMessageCallback) {
            this.onMessageCallback(parsedEvent);
        }
        else {
            this.queue.push(parsedEvent);
        }
    }
}
export function parseFormat(format) {
    const [formatPart, sampleRatePart] = format.split("_");
    if (!["pcm", "ulaw"].includes(formatPart)) {
        throw new Error(`Invalid format: ${format}`);
    }
    const sampleRate = Number.parseInt(sampleRatePart);
    if (Number.isNaN(sampleRate)) {
        throw new Error(`Invalid sample rate: ${sampleRatePart}`);
    }
    return {
        format: formatPart,
        sampleRate,
    };
}
//# sourceMappingURL=BaseConnection.js.map